module.exports = __webpack_public_path__ + "static-portal/img/yhz-zxhy1.f540ca5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yhz-zxhy1.jpg
// module id = UcsX
// module chunks = 4